import script from "./CandidateChallengeCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CandidateChallengeCard.vue?vue&type=script&setup=true&lang=js"

import "./CandidateChallengeCard.vue?vue&type=style&index=0&id=035ff6ca&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-035ff6ca"]])

export default __exports__